import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import 'jquery';
import {ConfigService} from './config.service';
import {AngularCsv} from "angular7-csv";
import {AuthService} from "@auth0/auth0-angular";
import {TokenService} from "./token.service";
import {ParticipantApiResponse} from "../liste-des-participants/participant-detail-drawer/participant-detail-drawer.types";
import {ListeControle, RawListe, ListStatePatch, mapRawToListe} from "../mes-listes-controle/mes-listes.model";
import {MemberPermissions} from "./member-page-access.policy";

declare var $: any;

@Injectable()
export class BoService {
  url: string = this.configService.apiControlUrl + "/api";
  getcust = '0';

  constructor(public http: HttpClient, private ngZone: NgZone, private router: Router, private configService: ConfigService, private auth: AuthService,
    private tokenService: TokenService,) {
  }

  signIn(mail) {
    let t = this;
    const options = '';
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set("email", mail)
            .set('authorization', this.tokenService.tokenApiControl);
          t.http.post('' + t.url + '/user/login', options, { headers })
            .toPromise()
            .then(data => {
              resolve(data);
            })
            .catch(error => {
              reject(error);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  // LISTS : -----------------------------------------------
  // getAllLists : bootstrap legacy — effets de bord (localStorage, sidebar, idevent).
  // Logique pure de normalisation/tri/filtre-membre déléguée à processRawListes (#4956).
  getAllLists(idevent: string) {
    let t = this;
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => t.waitForIdUser(8000))
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
            .set('authorization', this.tokenService.tokenApiControl);
          t.http.get('' + t.url + '/liste/list', { headers })
            .toPromise()
            .then(data => {
              const events = t.processRawListes((data as { message?: any[] })?.message ?? []);
              // any-justifié: ev est un RawListe blob non typé provenant de localStorage
              let ev: any = idevent.length > 1
                ? events.find(e => (e._id as string).includes(idevent))
                : undefined;
              if (!ev) ev = events[0];
              // Écrit même vide : dataAllLists reflète les listes visibles du compte courant.
              localStorage.setItem('dataAllLists', JSON.stringify(events));
              if (ev) {
                localStorage.setItem('dataList', JSON.stringify(ev));
                t.updateSidebarDOM(ev);
              }
              resolve(events);
            }).catch(error => {
              console.log(error);
              reject(error);
            });
        }).catch(err => {
          reject(err);
        });
    });
  };

  // MES LISTES (refonte wilout/issues#4956) : -----------------------------------------------

  /** Récupère et mappe les listes de contrôle sans toucher au DOM ni à l'état global. */
  fetchListsModel(): Promise<ListeControle[]> {
    const t = this;
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => t.waitForIdUser(8000))
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
            .set('authorization', t.tokenService.tokenApiControl);
          t.http.get('' + t.url + '/liste/list', { headers })
            .toPromise()
            .then((data: { message?: RawListe[] }) => {
              const events: RawListe[] = t.processRawListes(data?.message ?? []);
              resolve(events.map(mapRawToListe));
            })
            .catch(error => reject(error));
        })
        .catch(err => reject(err));
    });
  }

  /** Normalise les dates, calcule isPast, trie (actives par création asc, expirées desc), filtre membre. */
  processRawListes(events: RawListe[]): RawListe[] {
    const now = new Date();
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    const nowdate = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}`;
    const toKey = (d: string) => {
      const s = d.split('');
      return s[6] + s[7] + s[8] + s[9] + s[3] + s[4] + s[0] + s[1] + s[11] + s[12] + s[14] + s[15];
    };
    const active: RawListe[] = [];
    const past: RawListe[] = [];
    for (const ev of events) {
      if (!ev.creationDate || ev.creationDate.length !== 19) ev.creationDate = '01-01-2000 00:00:01';
      if (!ev.dateEndValide || ev.dateEndValide.length !== 19) ev.dateEndValide = '31-12-2100 23:59:59';
      if (!Array.isArray(ev.tpl)) ev.tpl = [];
      ev['sd'] = toKey(ev.creationDate);
      ev['ed'] = toKey(ev.dateEndValide);
      ev.isPast = false;
      if (parseFloat(ev['ed'] as string) > parseFloat(nowdate)) {
        active.push(ev);
      } else {
        ev.isPast = true;
        past.push(ev);
      }
    }
    active.sort((a, b) => parseInt(a['sd'] as string) - parseInt(b['sd'] as string));
    past.sort((a, b) => parseInt(b['sd'] as string) - parseInt(a['sd'] as string));
    let merged = active.concat(past);

    const isMember = localStorage.getItem('isMember') === 'true';
    if (isMember) {
      try {
        const mp: Partial<MemberPermissions> = JSON.parse(localStorage.getItem('memberPermissions') || '{}');
        const allowed: string[] = mp.enableList || [];
        // enableList vide = toutes les listes : un accès refusé (#8627) n'en reçoit aucune.
        if (mp.accessDenied === true) merged = [];
        else if (allowed.length > 0) merged = merged.filter(e => allowed.includes(e._id));
      } catch (e) { /* noop */ }
    }
    return merged;
  }

  /** Met à jour l'état d'une liste (isDefault / archived / hidden / flag) via PATCH /liste/state. */
  setListState(idList: string, patch: ListStatePatch): Promise<unknown> {
    let headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idList)
      .set('authorization', this.tokenService.tokenApiControl);
    if (patch.isDefault === true) {
      headers = headers.set("idorganisateur", JSON.parse(localStorage.getItem('idUser')));
    }
    return this.http.patch('' + this.url + '/liste/state', patch, { headers }).toPromise();
  }

  /** Duplique une liste de contrôle (#5420) via POST /liste/:idList/copies. */
  duplicateList(idList: string): Promise<RawListe> {
    const headers = new HttpHeaders()
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return this.http.post<RawListe>('' + this.url + '/liste/' + encodeURIComponent(idList) + '/copies', null, { headers }).toPromise();
  }

  /** Persiste le nouvel ordre des listes via POST /liste/reorder. */
  reorderLists(order: string[]): Promise<unknown> {
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return this.http.post('' + this.url + '/liste/reorder', { order }, { headers }).toPromise();
  }

  /** Met à jour les éléments sidebar (titre, date, nb tarifs, id) pour la liste courante. */
  private updateSidebarDOM(raw: RawListe): void {
    $('.titleEvent').html(raw.name);
    const dev = raw.dateEndValide;
    if (dev && dev.length >= 10) {
      $('.titleEventDate').html('Prévu le ' + dev.substring(0, 10).replace(/-/g, '/'));
    } else {
      $('.titleEventDate').html('');
    }
    const count = Array.isArray(raw.tpl) ? raw.tpl.length : 0;
    const countFmt = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    $('.listock').html(countFmt + (count > 1 ? ' tarifs' : ' tarif'));
    $('.myIdEvent').html(raw._id);
  }

  /** Lecture sûre de la liste courante (localStorage dataList) — {} si absente ou corrompue. */
  getCurrentList(): Partial<RawListe> {
    try {
      return JSON.parse(localStorage.getItem('dataList') || '{}') || {};
    } catch (e) {
      console.warn('[bo] dataList parse échoué', e);
      return {};
    }
  }

  /** Force le rechargement d'une route en rebondissant par /redirect (recrée le composant cible). */
  reloadRoute(target: string, skipLocationChange = false): Promise<boolean> {
    // Toute la chaîne dans ngZone.run : la navigation cible doit rester dans la zone Angular
    // quel que soit le contexte de l'appelant (callbacks jQuery notamment).
    return this.ngZone.run(() =>
      this.router.navigateByUrl('/redirect', { skipLocationChange })
        .then(() => this.router.navigateByUrl(target))
    );
  }

  /** Sélectionne une liste : persiste dataList, met à jour la sidebar, recharge la page courante. */
  selectListRaw(raw: RawListe): Promise<boolean> {
    const t = this;
    localStorage.setItem('dataList', JSON.stringify(raw));
    t.updateSidebarDOM(raw);
    // router.url et non window.location.hash : l'app est en path routing, le hash est
    // toujours vide et renvoyait sur la route par défaut au lieu de la page courante (#5566).
    const currentUrl = t.router.url !== '/' ? t.router.url : '/tableau-de-bord';
    return t.reloadRoute(currentUrl, true);
  }

  /** Supprime une liste ; re-sélectionne la première restante ou redirige si plus aucune. */
  deleteListRaw(idList: string): Promise<unknown> {
    const t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idList)
      .set('authorization', t.tokenService.tokenApiControl);
    return t.http.delete('' + t.url + '/liste/delete', { headers })
      .toPromise()
      .then((data) => {
        let all: RawListe[] = [];
        try { all = JSON.parse(localStorage.getItem('dataAllLists') || '[]'); } catch (e) { all = []; }
        const remaining = all.filter(e => e._id !== idList);
        localStorage.setItem('dataAllLists', JSON.stringify(remaining));
        const current = t.getCurrentList();
        if (current && current['_id'] === idList) {
          if (remaining.length > 0) {
            return t.selectListRaw(remaining[0]).then(() => data);
          }
          return t.ngZone.run(() => t.router.navigateByUrl('/redirect-to-bo-online')).then(() => data);
        }
        return data;
      });
  }

  // ACCESS : -----------------------------------------------
  getAllKeys() {
    let t = this;
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => t.waitForIdUser(8000))
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
            .set('authorization', this.tokenService.tokenApiControl);
          t.http.get('' + t.url + '/staff/list', { headers })
            .toPromise()
            .then(data => {
              resolve(data['message']);
            }).catch(error => {
              console.log(error);
              reject(error);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  createList(data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);

    return new Promise((resolve, reject) => {
      t.http.put('' + t.url + '/liste/create', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editList(data) {
    let t = this;
    var idlist = t.getCurrentList()._id;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idlist)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/liste/mergeinfos', data, { headers })
        .toPromise()
        .then(data => {
          t.getAllLists(idlist).then(data0 => {
            resolve(data);
          }).catch(error => {
            resolve(data);
          });
        })
        .catch(error => {
          console.log(error);
          if (error.error.error == "Your token has expired") { t.expireToken(); };
          reject(error);
        });
    });
  };
  editTplList(data) {
    let t = this;
    var idlist = t.getCurrentList()._id;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idlist)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/liste/mergetemplate', data, { headers })
        .toPromise()
        .then(data => {
          t.getAllLists(idlist).then(data0 => {
            resolve(data);
          }).catch(error => {
            resolve(data);
          });
        })
        .catch(error => {
          console.log(error);
          if (error.error.error == "Your token has expired") { t.expireToken(); };
          reject(error);
        });
    });
  };
  // TPL : -----------------------------------------------
  getAllTpl() {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorga", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/event/getevents', { headers })
        .toPromise()
        .then(data => {
          resolve(data['events']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  getDataTpl() {
    let t = this;
    var idlist = t.getCurrentList()._id;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idlist)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/template/templatesByListWithScans', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']['tickets']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };

  private waitForIdUser(maxWaitMs: number = 8000): Promise<void> {
    const start = Date.now();
    return new Promise((resolve, reject) => {
      const check = () => {
        try {
          const raw = localStorage.getItem('idUser');
          if (raw && raw !== '' && raw !== 'undefined' && raw !== 'null') {
            JSON.parse(raw); // throws if not valid JSON
            resolve();
            return;
          }
        } catch (e) {
          // Invalid JSON: reject immediately instead of continuing to poll
          reject(new Error('idUser contains invalid JSON: ' + e.message));
          return;
        }
        if (Date.now() - start >= maxWaitMs) {
          reject(new Error('idUser not ready in localStorage'));
          return;
        }
        setTimeout(check, 100);
      };
      check();
    });
  }
  getDataKeys() {
    let t = this;
    var idlist = t.getCurrentList()._id;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idlist)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/staff/byListCount', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  createKey(data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.put('' + t.url + '/staff/create', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editKey(id, data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idstaff", id)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/staff/mergeinfos', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']['id']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editAllKeys(data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/staff/mergeall', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editKeyList(id, data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idstaff", id)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/staff/mergestaff', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']['id']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  removeKey(id) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idstaff", id)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.delete('' + t.url + '/staff/delete', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']['id']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  // BO ACCESS : ---------------------------------------------------
  getBoAccessList() {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/staff/bo', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  createBoAccess(data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorganisateur", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/staff/bo', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  mergeBoAccess(email, data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.patch('' + t.url + '/staff/bo/' + encodeURIComponent(email), data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  deleteBoAccess(email) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.delete('' + t.url + '/staff/bo/' + encodeURIComponent(email), { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  getMemberPermissions(email) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("email", email)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/staff/bo/permissions', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  // PARTICIPANTS : -----------------------------------------------
  getAllParticipants() {
    let t = this;
    var idlist = t.getCurrentList()._id;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idlist", idlist)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get('' + t.url + '/liste/participantsbylist', { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  getParticipantsPaginated(idList: string, params: {page?: number, limit?: number, search?: string, sortField?: string, sortOrder?: string, scanStatus?: string, flag?: string, ban?: string, nfcStatus?: string} = {}) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    let queryParams = new URLSearchParams();
    if (params.page) queryParams.set('page', params.page.toString());
    if (params.limit) queryParams.set('limit', params.limit.toString());
    if (params.search) queryParams.set('search', params.search);
    if (params.sortField) queryParams.set('sortField', params.sortField);
    if (params.sortOrder) queryParams.set('sortOrder', params.sortOrder);
    if (params.scanStatus) queryParams.set('scanStatus', params.scanStatus);
    if (params.flag) queryParams.set('flag', params.flag);
    if (params.ban) queryParams.set('ban', params.ban);
    if (params.nfcStatus) queryParams.set('nfcStatus', params.nfcStatus);
    const qs = queryParams.toString();
    const url = `${t.url}/liste/lists/${idList}/participants${qs ? '?' + qs : ''}`;
    return new Promise((resolve, reject) => {
      t.http.get(url, { headers })
        .toPromise()
        .then(data => {
          resolve(data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  // #5368 — "Tout exporter" : un seul appel serveur qui renvoie TOUS les participants
  // filtrés (pas de pagination → ni doublon ni manquant), mêmes filtres que la liste.
  getAllParticipantsForExport(idList: string, params: {search?: string, scanStatus?: string, flag?: string, ban?: string, nfcStatus?: string} = {}) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    let queryParams = new URLSearchParams();
    if (params.search) queryParams.set('search', params.search);
    if (params.scanStatus) queryParams.set('scanStatus', params.scanStatus);
    if (params.flag) queryParams.set('flag', params.flag);
    if (params.ban) queryParams.set('ban', params.ban);
    if (params.nfcStatus) queryParams.set('nfcStatus', params.nfcStatus);
    const qs = queryParams.toString();
    const url = `${t.url}/liste/lists/${idList}/participants/export${qs ? '?' + qs : ''}`;
    return new Promise((resolve, reject) => {
      t.http.get(url, { headers })
        .toPromise()
        .then(data => {
          resolve(data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  getParticipantsCount(idList: string) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get(`${t.url}/liste/lists/${idList}/participants/count`, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  getDashboardStats(idList: string) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get(`${t.url}/liste/lists/${idList}/dashboard-stats`, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editParticipant(idpar, data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idparticipant", idpar)
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/user/updateuser', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  editAllParticipants(data) {
    console.log(data);
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    //.set("idparticipant", '?????');
    return new Promise((resolve, reject) => {
      // t.http.post(''+t.url+'user/updateusermulti',data,{headers})
      t.http.post('' + t.url + '/user/updateusermulti', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['message']);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };
  // USER : -----------------------------------------------
  editInfoUser(data) {
    let t = this;
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("idorga", JSON.parse(localStorage.getItem('idUser')))
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/orga/updateorga', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  };









  // NFC : -----------------------------------------------
  associateNfc(idList: string, idParticipant: string, nfcTag: string) {
    let t = this;
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set('authorization', this.tokenService.tokenApiControl);
          t.http.patch('' + t.url + '/scan/lists/' + idList + '/participants/' + idParticipant, { associatedNfc: nfcTag }, { headers })
            .toPromise()
            .then(data => {
              resolve(data);
            }).catch(error => {
              console.log(error);
              reject(error);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  };
  async getParticipant(idList: string, idParticipant: string): Promise<ParticipantApiResponse> {
    await this.tokenService.waitForTokenApiControl(8000);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return this.http
      .get<ParticipantApiResponse>(this.url + '/scan/lists/' + idList + '/participants/' + idParticipant, { headers })
      .toPromise();
  }

  disassociateNfc(idList: string, idParticipant: string) {
    let t = this;
    return new Promise((resolve, reject) => {
      t.tokenService.waitForTokenApiControl(8000)
        .then(() => {
          const headers = new HttpHeaders()
            .set("Content-Type", 'application/json')
            .set('authorization', this.tokenService.tokenApiControl);
          t.http.delete('' + t.url + '/scan/lists/' + idList + '/participants/' + idParticipant + '/nfc', { headers })
            .toPromise()
            .then(data => {
              resolve(data);
            }).catch(error => {
              console.log(error);
              reject(error);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  };
  //--- AUTRES SERVICES : -------------------------------------------------------
  newPassword(oldpass, newpass) {
    let t = this;
    var n = '';
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("authorization", JSON.parse(localStorage.getItem('dataUser'))["token"])
      .set("idcustomer", JSON.parse(localStorage.getItem('dataUser'))["_id"])
      .set("oldpassword", JSON.stringify(oldpass))
      .set("newpassword", JSON.stringify(newpass));
    return new Promise((resolve, reject) => {
      t.http.post('' + t.url + '/customer/api/newPassword', n, { headers })
        .toPromise()
        .then(data => {
          resolve(data);
        }).catch(error => {
          console.log(error);
          if (error.error.error == "Your token has expired") { t.expireToken(); };
          reject(error);
        });
    });
  };
  createCsv(data, name, options) {
    new AngularCsv(data, name, options);
  };
  createPdf(html, css) {
    let t = this;
    var head = '<div class="headPdf" style="font-family:Arial,Helvetica,sans-serif;float:left;width:100%;height:40px;box-sizing:border-box;line-height:50px;padding-left:5%;padding-right:5%;border-left:solid 4px #e83a43;background-image: linear-gradient(90deg, #e83a43 -20%, #f1f1f1 10%);"><div class="logo" style="float:left;height:100%;width:34px;"><svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 283.5 283.5" width="25px" height="25px" style="enable-background:new 0 0 283.5 283.5;fill:#e83a43;transform:translateY(4px)" xml:space="preserve"> <g> <g> <path d="M216.8,193c0-1.5,0-2.4,0-3.4c0-26,0-52.1-0.1-78.1c0-2.9,0.7-4.6,3.5-6.1c7-3.6,13.8-7.6,20.7-11.4 c3.7-2,5.8-0.6,5.8,3.5c0,39.8,0,79.5,0,119.3c0,6-2.7,10.6-7.8,13.2c-5.1,2.6-10.6,2.5-15.8-0.4c-8.8-4.9-17.6-9.8-26.5-14.7 c-7.6-4.2-15.1-8.5-22.7-12.7c-9.4-5.2-19.1-10.1-28.3-15.7c-3.8-2.3-6.4-1.8-9.8,0.2c-10.9,6.4-22,12.5-33.1,18.7 c-10.1,5.6-20.2,11-30.3,16.5c-5,2.7-9.9,5.5-14.9,8.2c-3.9,2.1-12,2.4-16.9-2.3c-4.2-3.9-5.9-9.9-4.1-14.7 c1.9-5.2,6.1-7.9,10.5-10.3c10.9-6,21.9-11.9,32.8-17.9c8.9-4.9,17.7-10,26.5-14.9c9.4-5.2,18.9-10.4,28.5-15.3 c3.9-2,8.3-2,12.3,0.1c7.4,3.8,14.6,7.9,21.9,11.9c13.9,7.7,27.8,15.4,41.7,23.2C212.7,191,214.5,191.9,216.8,193z"/> <path class="st0" d="M66,90.6c0,1.6,0,2.7,0,3.7c0,26.2-0.1,52.4,0.1,78.6c0,3.1-1.2,4.5-3.8,5.9c-5.5,3-11.1,6.2-16.7,9.3 c-1.8,1-3.6,1.9-5.5,2.6c-2,0.7-3.3-0.2-3.5-2.3c-0.1-0.6,0-1.2,0-1.9c0-39.7,0.1-79.5-0.1-119.2c0-5.7,2.7-9.3,6.5-12.7 c4-3.6,8.9-3.6,13.6-2.4c2.7,0.7,5,2.3,7.5,3.7c10.7,5.9,21.4,12.4,32.1,18.3c10.6,5.9,21.2,11.8,31.8,17.8 c4.3,2.4,8.6,4.9,13,7.2c0.8,0.4,2.1,0.4,2.9,0c6.6-3.6,13.1-7.3,19.7-10.9c9.9-5.5,19.9-10.8,29.8-16.3 c6.8-3.8,13.6-7.6,20.3-11.4c4.9-2.7,9.6-5.8,14.6-8c3.4-1.5,7.6-1.2,11,0.7c2.4,1.3,4.1,2.8,5.6,4.8c4.7,6,3.3,16.4-4.8,20.8 c-15.4,8.4-30.7,16.9-46,25.4c-9.8,5.5-19.5,11-29.4,16.5c-5.1,2.8-10.2,5.6-15.5,8.1c-4.6,2.1-9.5,2.3-14-0.2 c-16.8-9.2-33.6-18.5-50.4-27.8c-5.3-3-10.7-5.9-16.1-8.8C68.1,91.4,67.2,91.2,66,90.6z"/> </g> </g> </svg></div><div class="name" style="float:left;height:100%;width:67px;line-height:42px;font-size:10px;">WILOUT PAY</div><div class="slogan" style="float:left;height:100%;width:150px;line-height:42px;font-size:8px;color:#777777">- &nbsp; Paiement cashless</div><div class="com" style="float:right;height:100%;line-height:42px;text-align:right;font-size:8px;color:#a5a5a5">Découvrez toutes nos gammes sur <span style="color:#777777">www.wilout.com</span>&nbsp; </div></div>';
    var footer = '<div class="footerPdf" style="font-family:Arial,Helvetica,sans-serif;width:100%;height:70px;bottom:8px;background-color:#f1f1f1;text-align:center;padding-top:20px;"><div class="editinfo" style="width:100%;margin-top:5px;color:#777777;font-size:7px;font-weight:400;">Document généré par la société Wilout pour le compte de Jao Events Group.</div><div class="wiloutContact" style="width:100%;margin-top:10px;color:#777777;font-size:7px;font-weight:600;">Adresse e-mail de contact : support@jao-events.com</div><div class="wiloutInfo" style="width:100%;margin-top:6px;line-height:9px;color:#a5a5a5;font-size:6px;font-weight:400;">SAS WILOUT au capital de 926,50 € - SIRET 820 656 346 00021 - RCS de Antibes<br>Siège social : 22 avenue Auguste Renoir, 06800, Cagnes-sur-mer Web</div></div>';
    var data = { "html": html, "css": css, "pdf_margins": "130px 0px 110px 0px", "pdf_header": head, "pdf_footer": footer, "json": "true" };
    const headers = new HttpHeaders()
      .set("Content-Type", 'application/json')
      .set("x-access-token", 'mmG5jxuM6VzBPgDGpHWWx7LJ47XIoZ6CdLETp8CP7XL3JrmN');
    return new Promise((resolve, reject) => {
      t.http.post('https://restpack.io/api/html2pdf/v6/convert', data, { headers })
        .toPromise()
        .then(data => {
          resolve(data['file']);
        })
        .catch(error => {
          console.log(error);
          if (error.error.error == "Your token has expired") { t.expireToken(); };
          reject(error);
        });
    });
  };
  expireToken() {
    let t = this;
    localStorage.setItem('authUser', 'false');
    localStorage.setItem('dataUser', '');
    localStorage.setItem('dataEvent', '');
    localStorage.setItem('dataAllEvents', '');
    t.ngZone.run(() => t.router.navigateByUrl('/deconnecte'));
  };

  errorLoad(err?: any) {
    if (err !== undefined) {
      // Log détaillé de l'erreur si disponible
      console.error('[ErrorLoad]', err);
    } else {
      // Log générique si aucun objet erreur n'est passé
      console.error('[ErrorLoad] Une erreur est survenue (aucun objet d\'erreur fourni).');
    }
    $('.messError').fadeIn(500);
    $('.blocLoader').fadeOut(500);
  };
  screenMode(a, b) {
    // '#' + router.url et non window.location.hash (toujours vide en path routing, #5566) :
    // conserve les comparaisons '#/route' existantes, query params exclus.
    const wlh = '#' + this.router.url.split('?')[0];
    // Logo du header : encre foncee sur fond clair, version claire en mode sombre
    // (equivalent du couple logoDefault / logoDark du BO cashless). Pose ici et
    // non en CSS : ce BO ne renseigne pas data-theme, il bascule en styles inline.
    $('.logowilout0').attr('src', a == 'on'
      ? 'logos/light/logo-symbol-color.svg'
      : 'logos/dark/logo-symbol-color.svg');
    if (a == 'on') {
      // global (sur toute les pages)
      $('body,.inae').css({ 'background-color': 'var(--ui-color-bg-page)' });
      $('.headerbo,.multievbtn,.addevbtn,.mlA,.confremoveme,.blocaddevent,.headae,.blocedit,.bloconfdeco,.headedit').css({ 'background-color': 'var(--ui-color-bg)' });
      $('.titpast').css({ 'background-color': 'color-mix(in srgb, var(--ui-color-primary-dark) 60%, transparent)' });
      $('.statusme').css({ 'background-color': 'var(--ui-color-bg-muted)' });
      $('.contstatusme').css({ 'background-image': 'linear-gradient(to right, transparent, var(--ui-color-bg) 18%)' });
      $('.fdpop').css({ 'background-image': 'linear-gradient(140deg, color-mix(in srgb, var(--ui-color-primary-dark) 40%, transparent), color-mix(in srgb, var(--ui-color-primary-dark) 30%, transparent) 100%)' });
      $('.titpast').css({ 'border-color': 'var(--ui-color-bg)' });
      $('.headae,.headedit').css({ 'border-color': 'var(--ui-color-border)' });
      $('.multievbtn,.addevbtn').css({ 'border-color': 'var(--ui-color-border)' });
      $('.multievbtn,.addevbtn').css({ 'box-shadow': '0px 3px 8px -1px rgb(0, 0, 0, 0.25)' });
      $('.headerbo').css({ 'color': 'var(--ui-color-text-secondary)' });
      $('#htitsec,.dateml,.coevml,.confremoveme,.textconfdeco').css({ 'color': 'var(--ui-color-text-secondary)' });
      $('.multievbtn,.addevbtn,.btncancelremoveme').css({ 'color': 'var(--ui-color-text)' });
      $('#htitsec2,.titml,.labelae,.inae').css({ 'color': 'var(--ui-color-text)' });
      $('.decobtn').css({ 'fill': 'var(--ui-color-text-subtle)' });
      $('.dateml,.coevml').css({ 'fill': 'var(--ui-color-text-secondary)' });
      if (wlh == '#/tableau-de-bord') {
        // background-color
        $('.s4,.b2,.b3,.barprog').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.hs4,.blocbas,.blocbas,.blocrist,.b7,.b8,.b9,.b10,.btneditevT').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.jaugeacs,.jaugetpl').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.b1,.b6,.contlistpay,.listacstdb,.listtpltdb,.blocaccestdb,.bloctpltdb,.itpay,.sliderZoom,.btngoconflist,.btnserv,.listplb').css({ 'background-color': 'var(--ui-color-bg)' });
        $('.contzoom,.btnswitchacs,.btnswitchtpl,.btnrefreshT,.btntriacstdb,.btntritpltdb,.txtlabZoom').css({ 'background-color': 'var(--ui-color-bg-muted)' });
        $('.sliderhandZoom').css({ 'background-color': 'var(--ui-color-border)' });
        $('.btnphoneT,.linktoshop').css({ 'background-color': 'var(--ui-color-text)' });
        // background-image
        $('.fdpopedit').css({ 'background-image': 'linear-gradient(140deg, color-mix(in srgb, var(--ui-color-primary-dark) 40%, transparent), color-mix(in srgb, var(--ui-color-primary-dark) 30%, transparent) 100%)' });
        $('.prog').css({ 'background-image': 'linear-gradient(to right, var(--ui-color-bg-page), var(--ui-color-bg-muted))' });
        $('.hs4').css({ 'background-image': 'linear-gradient(to bottom, var(--ui-color-bg), var(--ui-color-bg-page))' });
        // border
        $('.b2,.b3').css({ 'border': 'none' });
        // border-color
        $('.jaugeacs,.jaugetpl,.hs4,.blocbas,.blocbas,.blocrist,.b7,.b8,.b9,.b10').css({ 'border-color': 'var(--ui-color-bg-page)' });
        $('.minper').css({ 'border-color': 'var(--ui-color-bg-page)' });
        $('.tot').css({ 'border-color': 'var(--ui-color-bg)' });
        $('.blocinfotext,.mtntot,.titlistpay,.ast,.litb,.btnhelpT,.btnserv').css({ 'border-color': 'var(--ui-color-border)' });
        $('.btnswitchacs,.btnswitchtpl').css({ 'border-color': 'transparent' });
        $('.sliderhandZoom,.contactrist').css({ 'border-color': 'var(--ui-color-text-secondary)' });
        $('.btnphoneT,.linktoshop').css({ 'border-color': 'var(--ui-color-text)' });
        // border-top-color
        $('.listacstdb,.listtpltdb,.contlistpay,.listep').css({ 'border-top-color': 'var(--ui-color-border)' });
        // box-shadow
        $('.tot,.btngoconflist').css({ 'box-shadow': '0 2.5px 0px 0px var(--ui-color-bg-muted)' });
        $('.contzoom,.btnswitchacs,.btnswitchtpl,.btnrefreshT').css({ 'box-shadow': '0 2.5px 0px 0px var(--ui-color-border)' });
        $('.blocappa').css({ 'box-shadow': '0 12px 38px -5px color-mix(in srgb, var(--ui-color-primary) 23%, transparent), 0 7px 20px -4px color-mix(in srgb, var(--ui-color-primary-dark) 14%, transparent)' });
        // color
        $('.btnphoneT,.linktoshop').css({ 'color': 'var(--ui-color-bg-page)' });
        $('.iclabZoom').css({ 'color': 'var(--ui-color-bg-muted)' });
        $('.iczoomMoins,.ndg,.nolastc,.noitacs,.noittpl').css({ 'color': 'var(--ui-color-text-subtle)' });
        $('.slidebas,.contpucebas,.contrist1,.contrist2,.textprogstep,.stepT,.ast').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('.itpay,.btnrefreshT,.btntriacstdb,.btntritpltdb,.btngoconflist,.titlistpay,.tit,.hs4,.titbas,.titrist,.titconf,.titast,.titcontact,.titmore,.datev,.adressev,.nameitb,.respdis5,.casJt,.btnserv,.btneditevT,.iceditaccestdb,.icedittpltdb').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('.nbscanitb').css({ 'color': 'var(--ui-color-text)' });
        $('.typels,.namels,.btnswitchacs,.btnswitchtpl,.nameacs,.nametpl,.mtntot,.mtnpay,#mtntpltocheck,.txttbs,.txttbs2,.titev,.titshop,.titgraph,.selectb6,.recettestexte,.titaccestdb,.titbloctpltdb,.contactrist,.arrbasleft,.arrbasright,.btnhelpT,.txtlabZoom,.bodinfoAppa').css({ 'color': 'var(--ui-color-text)' });
        // opacity
        $('.casJt').css({ 'opacity': '1.0' });
        $('.graphE').css({ 'opacity': '0.2' });
        // padding-left
        $('.s4').css({ 'padding-left': '1px' });
        // specific class
        $('.listacstdb,.listtpltdb,.contlistpay,.titinfotext,.infotexttdb').addClass('cldm');
        $('.litb').addClass('lidm');
        $('.sliderhandZoom').addClass('cdm1');
        $('.itpayg').addClass('cdm2');
        $('.blocbas,.blocbas,.blocrist,.b7,.b8,.b9,.b10').addClass('cdm3');
        $('.itpay').addClass('cdm4');
        $('.btngoconflist').addClass('btndm1');
        $('.contzoom,.btnswitchacs,.btnswitchtpl,.btnrefreshT').addClass('btndm2');
        $('.btnphoneT,.btnserv').addClass('btndm3');
        $('.btneditevT').addClass('btndm4');
        if (b == 'on') {
          $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.datev,.adressev,.txttbs2,.btngoconflist,.blocinfotext,.txtmtnpay,.btnrefreshT,.contzoom,.titlistpay,.tplls,.datels,.minper,.graphE,.texttotparT,.triacstdb,.tritpltdb,.blocbas,.blocrist,.b7,.b8,.b9,.b10').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
        };
      } else if (wlh == '#/liste-des-participants') {
        // background-color
        $('.casallsel').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.labsel,.blocacpar,.informpar').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.searchPar,.bulf,.contotpar,.htablp,.bloceditLP,.blocinfopar,.lscandet,.mscandet').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.lipar').css({ 'background-color': 'var(--ui-color-bg)' });
        $('.headerlp,.blocnfcpar,.blocsoldepar,.bloctranspar,.btnac,.bodsoldepar').css({ 'background-color': 'var(--ui-color-bg)' });
        $('.titinfopar').css({ 'background-color': 'color-mix(in srgb, var(--ui-color-primary-dark) 20%, transparent)' });
        $('.selepp,.cplparr,.cplp,.mtsoldepar').css({ 'background-color': 'var(--ui-color-bg-muted)' });
        // background-image
        $('.fdpopedit').css({ 'background-image': 'linear-gradient(140deg, color-mix(in srgb, var(--ui-color-primary-dark) 40%, transparent), color-mix(in srgb, var(--ui-color-primary-dark) 30%, transparent) 100%)' });
        $('.footerlp').css({ 'background-image': 'linear-gradient(transparent, var(--ui-color-bg-page))' });
        // border-color
        $('.htablp,.footerlp').css({ 'border-color': 'var(--ui-color-bg)' });
        $('.lipar').css({ 'border-color': 'var(--ui-color-border-muted)' });
        $('.titnfcpar,.titsoldepar,.tittranspar').css({ 'border-color': 'var(--ui-color-border)' });
        // box-shadow
        $('.headerlp').css({ 'box-shadow': '0 10px 30px -2px rgb(0, 0, 0, 0.17)' });
        $('.bloceditLP').css({ 'box-shadow': '0px 0px 70px 0px rgba(0,0,0,0.4)' });
        // color
        $('.messdettrans').css({ 'color': 'var(--ui-color-bg-muted)' });
        $('.htc,.searchiclp,.accountnum,.labelformpar,.labelinfonfc,.infosoldepar,.tittritranspar').css({ 'color': 'var(--ui-color-text-subtle)' });
        $('.icparld,.bulf').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('.lipar,.contreslp,.contpage,.titacpar,.lscandet,.mscandet,.informpar,.valinfonfc,.liinfonfcmore,.infobulf').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('#mtotpar,.rpp,.cplparr,.cplp,.titinfopar,.titnfcpar,.titsoldepar,.tittranspar,.mtsoldepar,.searchPar').css({ 'color': 'var(--ui-color-text)' });
        // fill
        $('.titnfcpar').css({ 'fill': 'var(--ui-color-text-secondary)' });
        // specific class
        $('.lipar').addClass('cdmlp0');
        $('.lpg').addClass('cdmlp1');
        $('.searchPar').addClass('cdmlp2');
        $('.cplparroff,.cplpoff').addClass('cdmlp3');
        $('.contcirclescan').addClass('cdmlp4');
        $('.htc').addClass('cdmlp5');
        $('.cs0').addClass('cdmlp6');
        $('.informmail').addClass('cdmlp7');
        if (b == 'on') {
          $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.countselmt,.countseltxt,.cutrespact,.selactlp,.bulf,.searchPar,.htc,.ltcf,.ltcdate,.ltcname,.ltcmail,.ltctpl,.ltckey,.contreslp,.contpage,.accountnum,.formpar,.infonfcpar,.liinfonfc,.lscandet,.mscandet,.infosoldepar,.tittritranspar,.accesscan,.datscan,.blocacpar').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
        };
      } else if (wlh == '#/configurer-general') {
        // background-color
        $('.contcodig').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.contpublish,.inig').css({ 'background-color': 'var(--ui-color-bg-page)' });
        $('.headerig,.circlepublish,.blocig,.buladdPa').css({ 'background-color': 'var(--ui-color-bg)' });
        $('.bulCheckPa').css({ 'background-color': 'var(--ui-color-bg-muted)' });
        // border-color
        $('.contcodig').css({ 'border-color': 'var(--ui-color-bg)' });
        $('.hbig,.contintegration').css({ 'border-color': 'var(--ui-color-border)' });
        // box-shadow
        $('.headerig').css({ 'box-shadow': '0 10px 30px -2px rgb(0, 0, 0, 0.17)' });
        $('.blocig').css({ 'box-shadow': '0 5px 14px -2px rgb(0, 0, 0, 0.17)' });
        // color
        $('.buladdPa').css({ 'color': 'var(--ui-color-text-subtle)' });
        $('.txtintegration,.nameaddPa,.bulCheckPa').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('.blocmodif,.annulmod,.hbig,.linktoga,.inig').css({ 'color': 'var(--ui-color-text-secondary)' });
        $('.contpublish,.labelig,.namePa').css({ 'color': 'var(--ui-color-text)' });
        // specific class
        $('#indescri').addClass('cdmcg1');
        $('.inig').addClass('cdmcg2');
        $('.btnsaveigoff').addClass('cdmcg3');
        $('.labpublish').addClass('cdmcg4');
        $('.itPa ').addClass('cdmcg5');
        $('.itaddPa').addClass('cdmcg6');
        if (b == 'on') {
          $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.txtetatig,.hbig,.inig,.titframe,.txtintegration,.itaddPa').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
        };
      } else {
        // finir les autres pages sans oublier le mode contraste à chaque fois
        $('div,body,p,span,input,label,textarea,svg,img,select').each(function (this: HTMLElement) {
          var ti = $(this);
          var tib = ti.css("backgroundColor");
          var tic = ti.css("color");
          var tir = ti.css("borderColor");
          var tif = ti.css("fill");
          if (tib == 'undefined') { ti.css({ 'background-color': 'var(--ui-color-bg)' }); };
          if ((tib == 'rgb(255, 255, 255)') || (tib == "rgba(255, 255, 255, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg)' }); };
          if (tib == "rgba(255, 255, 255, 0.67)") { ti.css({ 'background-color': 'rgba(0, 47, 54, 0.67)' }); };
          if (tib == "rgba(255, 255, 255, 0.475)") { ti.css({ 'background-color': 'rgba(0, 47, 54, 0.48)' }); };
          if (tib == "rgba(255, 255, 255, 0.424)") { ti.css({ 'background-color': 'rgba(0, 47, 54, 0.42)' }); };
          if ((tib == 'rgb(253, 253, 253)') || (tib == "rgba(253, 253, 253, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg)' }); };
          if ((tib == 'rgb(250, 250, 250)') || (tib == "rgba(250, 250, 250, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if (tib == "rgba(248, 222, 219, 0.475)") { ti.css({ 'background-color': 'rgba(255, 135, 121, 0.18)' }); };
          if ((tib == 'rgb(247, 247, 247)') || (tib == "rgba(247, 247, 247, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(245, 245, 245)') || (tib == "rgba(245, 245, 245, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(241, 241, 241)') || (tib == "rgba(241, 241, 241, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(240, 240, 240)') || (tib == "rgba(240, 240, 240, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(238, 238, 238)') || (tib == "rgba(238, 238, 238, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(236, 236, 236)') || (tib == "rgba(236, 236, 236, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(233, 233, 233)') || (tib == "rgba(231, 231, 231, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(231, 231, 231)') || (tib == "rgba(231, 231, 231, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if ((tib == 'rgb(230, 230, 230)') || (tib == "rgba(230, 230, 230, 1.00)")) { ti.css({ 'background-color': 'var(--ui-color-bg-page)' }); };
          if (tib == "rgba(236, 236, 236, 0.475)") { ti.css({ 'background-color': 'rgba(0, 31, 35, 0.8)' }); };
          if (tib == "rgba(248, 197, 191, 0.475)") { ti.css({ 'background-color': 'rgba(151, 0, 0, 0.2)' }); };
          if ((tic == 'rgb(0, 0, 0)') || (tic == "rgba(0, 0, 0, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text)' }); };
          if ((tic == 'rgb(51, 51, 51)') || (tic == "rgba(51, 51, 51, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text)' }); };
          if ((tic == 'rgb(60, 60, 60)') || (tic == "rgba(60, 60, 60, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text)' }); };
          if ((tic == 'rgb(63, 63, 63)') || (tic == "rgba(63, 63, 63, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text)' }); };
          if ((tic == 'rgb(107, 107, 107)') || (tic == "rgba(240, 240, 240, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text-secondary)' }); };
          if ((tic == 'rgb(136, 136, 136)') || (tic == "rgba(136, 136, 136, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text-secondary)' }); };
          if ((tic == 'rgb(165, 165, 165)') || (tic == "rgba(165, 165, 165, 1.00)")) { ti.css({ 'color': 'var(--ui-color-text-secondary)' }); };
          if ((tir == 'rgb(245, 245, 245)') || (tir == "rgba(245, 245, 245, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border)' }); };
          if ((tir == 'rgb(243, 243, 243)') || (tir == "rgba(243, 243, 243, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border)' }); };
          if ((tir == 'rgb(238, 238, 238)') || (tir == "rgba(238, 238, 238, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tir == 'rgb(233, 233, 233)') || (tir == "rgba(233, 233, 233, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tir == 'rgb(232, 232, 232)') || (tir == "rgba(232, 232, 232, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tir == 'rgb(231, 231, 231)') || (tir == "rgba(231, 231, 231, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tir == 'rgb(229, 229, 229)') || (tir == "rgba(229, 229, 229, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tir == 'rgb(228, 228, 228)') || (tir == "rgba(228, 228, 228, 1.00)")) { ti.css({ 'border-color': 'var(--ui-color-border-muted)' }); };
          if ((tif == 'rgb(0, 0, 0)') || (tif == "rgba(0, 0, 0, 1.00)")) { ti.css({ 'fill': 'var(--ui-color-text)' }); };
          if ((tif == 'rgb(51, 51, 51)') || (tif == "rgba(51, 51, 51, 1.00)")) { ti.css({ 'fill': 'var(--ui-color-text)' }); };
          if ((tif == 'rgb(107, 107, 107)') || (tif == "rgba(240, 240, 240, 1.00)")) { ti.css({ 'fill': 'var(--ui-color-text-secondary)' }); };
          if ((tif == 'rgb(136, 136, 136)') || (tif == "rgba(136, 136, 136, 1.00)")) { ti.css({ 'fill': 'var(--ui-color-text-secondary)' }); };
          if ((tif == 'rgb(165, 165, 165)') || (tif == "rgba(165, 165, 165, 1.00)")) { ti.css({ 'fill': 'var(--ui-color-text-subtle)' }); };
          $('.headerbo').css({ 'box-shadow': '0px 2px 8px rgb(0,0,0,.15)' });
        });
        if (b == 'on') {
          if (wlh == '#/configurer-ma-liste') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.searchTpl,.contLiTpl').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          } else if (wlh == '#/gerer-les-acces') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.searchga,.headerInfoGa,.menuK,.totnblist,.continopK,.countLK,.tplLK').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          } else if (wlh == '#/mes-informations') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.liformi,.bloctxtmi').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          } else if (wlh == '#/parametres') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.liforparam,.btnshare,.txtparam').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          } else if (wlh == '#/aide') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.headersp,.blochelp,.blocast,.blocblog').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          } else if (wlh == '#/support') {
            $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.headersp,.blocmessage,.bloccontact').css({ 'filter': 'brightness(1.4) contrast(1.4) saturate(0)' });
          };
        };
      };
    } else if (b == 'on') {
      if (wlh == '#/tableau-de-bord') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.datev,.adressev,.txttbs2,.btngoconflist,.blocinfotext,.txtmtnpay,.btnrefreshT,.contzoom,.titlistpay,.tplls,.datels,.minper,.graphE,.texttotparT,.triacstdb,.tritpltdb,.blocbas,.blocrist,.b7,.b8,.b9,.b10').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/liste-des-participants') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.countselmt,.countseltxt,.cutrespact,.selactlp,.bulf,.searchPar,.htc,.ltcf,.ltcdate,.ltcname,.ltcmail,.ltctpl,.ltckey,.contreslp,.contpage,.accountnum,.formpar,.infonfcpar,.liinfonfc,.lscandet,.mscandet,.infosoldepar,.tittritranspar,.accesscan,.datscan,.blocacpar').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/configurer-general') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.txtetatig,.hbig,.inig,.titframe,.txtintegration,.itaddPa').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/configurer-ma-liste') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.searchTpl,.contLiTpl').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/gerer-les-acces') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.searchga,.headerInfoGa,.menuK,.totnblist,.continopK,.countLK,.tplLK').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/mes-informations') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.liformi,.bloctxtmi').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/parametres') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.liforparam,.btnshare,.txtparam').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/aide') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.headersp,.blochelp,.blocast,.blocblog').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      } else if (wlh == '#/support') {
        $('#htitsec,#htitsec2,.multievbtn,.addevbtn,.decobtn,.headersp,.blocmessage,.bloccontact').css({ 'filter': 'brightness(0.66) contrast(3.4) saturate(0)' });
      };
    };
  };
  //--- DATA LOCALE : --------------------------------------------------------------------
  bas = [
    'Le tableau de bord vous offre un aperçu en temps réel de vos jauges et de vos entrées. Il regroupe aussi des raccourcis vers certaines sections de votre espace.',
    'Vous pouvez vous connecter sur les appareils de contrôle grâce à vos identifiants ou grâce à des accès personnalisables depuis la section <span class="linkbas linkbasGac">Points d\'accès <i class="fas fa-chevron-right"></i> Gérer les accès</span>.',
    'En cliquant sur l\'icône de Wilout en haut à gauche vous pouvez élargir le menu principal et détailler les différentes sections de votre backoffice.',
    'Comparez facilement vos données, en naviguant d\'une liste de contrôle à l\'autre depuis le menu <span class="linkbas linkbasMlc">Mes listes de contrôles</span> tout en restant sur la même page.',
    'Pour obtenir plus d\'informations et d\'astuces sur l\'utilisation de votre backoffice rendez-vous directement dans la section <span class="linkbas linkbasHelp">Assistance <i class="fas fa-chevron-right"></i> Aides et astuces</span>.'
  ];
  getFreeTplByEvent(idEvent: string) {
    let t = this;
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.get(`${t.url}/template/by-event/${idEvent}/free`, { headers })
        .toPromise()
        .then(data => { resolve(data); })
        .catch(error => { console.log(error); reject(error); });
    });
  }

  changeTpl(idList: string, idParticipant: string, newIdTplTicket: string) {
    let t = this;
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.patch(`${t.url}/scan/lists/${idList}/participants/${idParticipant}/tpl`, { idTplTicket: newIdTplTicket }, { headers })
        .toPromise()
        .then(data => { resolve(data); })
        .catch(error => { console.log(error); reject(error); });
    });
  }

  /**
   * Bulk-change tpl for a batch of participants.
   * Resolves with { updated, skipped, skippedDetails: [{idParticipant, reason}], code }
   * where `reason` is one of: 'CURRENT_TPL_NOT_FREE' | 'SAME_TPL' | 'REFUNDED_PAID_TICKET' | 'ACCREDITATION_TPL_LOCKED'.
   */
  bulkChangeTpl(idList: string, participantIds: string[], newIdTplTicket: string) {
    let t = this;
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authorization', this.tokenService.tokenApiControl);
    return new Promise((resolve, reject) => {
      t.http.patch(`${t.url}/scan/lists/${idList}/participants/bulk-tpl`, { idTplTicket: newIdTplTicket, participantIds }, { headers })
        .toPromise()
        .then(data => { resolve(data); })
        .catch(error => { console.log(error); reject(error); });
    });
  }

  // en attendant
  helpBook = [
    { name: 'Bientôt disponible !', content: 'Retrouvez ici, très prochainement, des dizaines d\'astuces et de conseils afin de maitriser parfaitement votre espace Wilout Control et d\'optimiser la gestion de votre public et de vos entrées.' }
  ];
}
